var _g, _g2, _circle, _g3, _g4, _circle2, _g5, _g6, _g7, _g8, _g9, _path, _path2, _g10, _g11, _ellipse, _ellipse2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 185,
    viewBox: "0 0 182 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_i_24_282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.2994,
    cy: 99.7007,
    r: 69.2994,
    fill: "#C4C4C4",
    fillOpacity: 0.01
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_24_282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.2994,
    cy: 99.7007,
    r: 69.2994,
    fill: "#C4C4C4",
    fillOpacity: 0.01
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2994,
    cy: 99.7007,
    r: 68.7994,
    stroke: "url(#paint0_linear_24_282)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_24_282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.2994,
    cy: 99.7007,
    r: 66.2994,
    stroke: "url(#paint1_linear_24_282)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.2994,
    cy: 99.7007,
    r: 66.2994,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_i_24_282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.2994,
    cy: 99.7007,
    r: 69.2994,
    fill: "#C4C4C4",
    fillOpacity: 0.01
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.2994,
    cy: 99.7007,
    r: 68.7994,
    stroke: "url(#paint2_linear_24_282)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter4_f_24_282)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.71,
    cy: 69.1814,
    rx: 9.51648,
    ry: 15.9257,
    transform: "rotate(45 72.71 69.1814)",
    fill: "#FF9BC5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter5_f_24_282)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.703,
    cy: 140.302,
    rx: 9.19614,
    ry: 18.8209,
    transform: "rotate(45 131.703 140.302)",
    fill: "#DF9BFF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_24_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9746 33.4796C56.5655 39.326 38.63 56.2462 31.3637 78.0446H31.3312V75.5315C39.169 54.4716 56.9538 38.2522 78.9746 32.5845V33.4796Z",
    fill: "#DFB9D7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_24_282)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4619,
    cy: 48.6441,
    rx: 10.3949,
    ry: 2.59873,
    transform: "rotate(-40.3806 50.4619 48.6441)",
    fill: "#D4AEBD"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter8_f_24_282)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4628,
    cy: 48.644,
    rx: 23.4331,
    ry: 5.85828,
    transform: "rotate(-40.3806 50.4628 48.644)",
    fill: "#D4AEBD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1875 128.383H61.6875C61.6094 129.102 61.4036 129.745 61.0703 130.312C60.737 130.88 60.2656 131.331 59.6562 131.664C59.0469 131.992 58.2865 132.156 57.375 132.156C56.7083 132.156 56.1016 132.031 55.5547 131.781C55.013 131.531 54.5469 131.177 54.1562 130.719C53.7656 130.255 53.4635 129.701 53.25 129.055C53.0417 128.404 52.9375 127.68 52.9375 126.883V125.75C52.9375 124.953 53.0417 124.232 53.25 123.586C53.4635 122.935 53.7682 122.378 54.1641 121.914C54.5651 121.451 55.0469 121.094 55.6094 120.844C56.1719 120.594 56.8047 120.469 57.5078 120.469C58.3672 120.469 59.0938 120.63 59.6875 120.953C60.2812 121.276 60.7422 121.724 61.0703 122.297C61.4036 122.865 61.6094 123.523 61.6875 124.273H60.1875C60.1146 123.742 59.9792 123.286 59.7812 122.906C59.5833 122.521 59.3021 122.224 58.9375 122.016C58.5729 121.807 58.0964 121.703 57.5078 121.703C57.0026 121.703 56.5573 121.799 56.1719 121.992C55.7917 122.185 55.4714 122.458 55.2109 122.812C54.9557 123.167 54.763 123.591 54.6328 124.086C54.5026 124.581 54.4375 125.13 54.4375 125.734V126.883C54.4375 127.44 54.4948 127.964 54.6094 128.453C54.7292 128.943 54.9089 129.372 55.1484 129.742C55.388 130.112 55.6927 130.404 56.0625 130.617C56.4323 130.826 56.8698 130.93 57.375 130.93C58.0156 130.93 58.526 130.828 58.9062 130.625C59.2865 130.422 59.5729 130.13 59.7656 129.75C59.9635 129.37 60.1042 128.914 60.1875 128.383ZM65.0938 120V132H63.6406V120H65.0938ZM68.9844 123.547V132H67.5312V123.547H68.9844ZM67.4219 121.305C67.4219 121.07 67.4922 120.872 67.6328 120.711C67.7786 120.549 67.9922 120.469 68.2734 120.469C68.5495 120.469 68.7604 120.549 68.9062 120.711C69.0573 120.872 69.1328 121.07 69.1328 121.305C69.1328 121.529 69.0573 121.721 68.9062 121.883C68.7604 122.039 68.5495 122.117 68.2734 122.117C67.9922 122.117 67.7786 122.039 67.6328 121.883C67.4922 121.721 67.4219 121.529 67.4219 121.305ZM74.6875 130.969C75.0312 130.969 75.349 130.898 75.6406 130.758C75.9323 130.617 76.1719 130.424 76.3594 130.18C76.5469 129.93 76.6536 129.646 76.6797 129.328H78.0547C78.0286 129.828 77.8594 130.294 77.5469 130.727C77.2396 131.154 76.8359 131.5 76.3359 131.766C75.8359 132.026 75.2865 132.156 74.6875 132.156C74.0521 132.156 73.4974 132.044 73.0234 131.82C72.5547 131.596 72.1641 131.289 71.8516 130.898C71.5443 130.508 71.3125 130.06 71.1562 129.555C71.0052 129.044 70.9297 128.505 70.9297 127.938V127.609C70.9297 127.042 71.0052 126.505 71.1562 126C71.3125 125.49 71.5443 125.039 71.8516 124.648C72.1641 124.258 72.5547 123.951 73.0234 123.727C73.4974 123.503 74.0521 123.391 74.6875 123.391C75.349 123.391 75.9271 123.526 76.4219 123.797C76.9167 124.062 77.3047 124.427 77.5859 124.891C77.8724 125.349 78.0286 125.87 78.0547 126.453H76.6797C76.6536 126.104 76.5547 125.789 76.3828 125.508C76.2161 125.227 75.987 125.003 75.6953 124.836C75.4089 124.664 75.0729 124.578 74.6875 124.578C74.2448 124.578 73.8724 124.667 73.5703 124.844C73.2734 125.016 73.0365 125.25 72.8594 125.547C72.6875 125.839 72.5625 126.164 72.4844 126.523C72.4115 126.878 72.375 127.24 72.375 127.609V127.938C72.375 128.307 72.4115 128.672 72.4844 129.031C72.5573 129.391 72.6797 129.716 72.8516 130.008C73.0286 130.299 73.2656 130.534 73.5625 130.711C73.8646 130.883 74.2396 130.969 74.6875 130.969ZM81.1328 120V132H79.6797V120H81.1328ZM86.2969 123.547L82.6094 127.492L80.5469 129.633L80.4297 128.094L81.9062 126.328L84.5312 123.547H86.2969ZM84.9766 132L81.9609 127.969L82.7109 126.68L86.6797 132H84.9766ZM95.2969 123.547V124.656H90.7266V123.547H95.2969ZM92.2734 121.492H93.7188V129.906C93.7188 130.193 93.763 130.409 93.8516 130.555C93.9401 130.701 94.0547 130.797 94.1953 130.844C94.3359 130.891 94.487 130.914 94.6484 130.914C94.7682 130.914 94.8932 130.904 95.0234 130.883C95.1589 130.857 95.2604 130.836 95.3281 130.82L95.3359 132C95.2214 132.036 95.0703 132.07 94.8828 132.102C94.7005 132.138 94.4792 132.156 94.2188 132.156C93.8646 132.156 93.5391 132.086 93.2422 131.945C92.9453 131.805 92.7083 131.57 92.5312 131.242C92.3594 130.909 92.2734 130.461 92.2734 129.898V121.492ZM96.4531 127.867V127.688C96.4531 127.078 96.5417 126.513 96.7188 125.992C96.8958 125.466 97.151 125.01 97.4844 124.625C97.8177 124.234 98.2214 123.932 98.6953 123.719C99.1693 123.5 99.7005 123.391 100.289 123.391C100.883 123.391 101.417 123.5 101.891 123.719C102.37 123.932 102.776 124.234 103.109 124.625C103.448 125.01 103.706 125.466 103.883 125.992C104.06 126.513 104.148 127.078 104.148 127.688V127.867C104.148 128.477 104.06 129.042 103.883 129.562C103.706 130.083 103.448 130.539 103.109 130.93C102.776 131.315 102.372 131.617 101.898 131.836C101.43 132.049 100.898 132.156 100.305 132.156C99.7109 132.156 99.1771 132.049 98.7031 131.836C98.2292 131.617 97.8229 131.315 97.4844 130.93C97.151 130.539 96.8958 130.083 96.7188 129.562C96.5417 129.042 96.4531 128.477 96.4531 127.867ZM97.8984 127.688V127.867C97.8984 128.289 97.9479 128.688 98.0469 129.062C98.1458 129.432 98.2943 129.76 98.4922 130.047C98.6953 130.333 98.9479 130.56 99.25 130.727C99.5521 130.888 99.9036 130.969 100.305 130.969C100.701 130.969 101.047 130.888 101.344 130.727C101.646 130.56 101.896 130.333 102.094 130.047C102.292 129.76 102.44 129.432 102.539 129.062C102.643 128.688 102.695 128.289 102.695 127.867V127.688C102.695 127.271 102.643 126.878 102.539 126.508C102.44 126.133 102.289 125.802 102.086 125.516C101.888 125.224 101.638 124.995 101.336 124.828C101.039 124.661 100.69 124.578 100.289 124.578C99.8932 124.578 99.5443 124.661 99.2422 124.828C98.9453 124.995 98.6953 125.224 98.4922 125.516C98.2943 125.802 98.1458 126.133 98.0469 126.508C97.9479 126.878 97.8984 127.271 97.8984 127.688ZM113.312 130.969C113.656 130.969 113.974 130.898 114.266 130.758C114.557 130.617 114.797 130.424 114.984 130.18C115.172 129.93 115.279 129.646 115.305 129.328H116.68C116.654 129.828 116.484 130.294 116.172 130.727C115.865 131.154 115.461 131.5 114.961 131.766C114.461 132.026 113.911 132.156 113.312 132.156C112.677 132.156 112.122 132.044 111.648 131.82C111.18 131.596 110.789 131.289 110.477 130.898C110.169 130.508 109.938 130.06 109.781 129.555C109.63 129.044 109.555 128.505 109.555 127.938V127.609C109.555 127.042 109.63 126.505 109.781 126C109.938 125.49 110.169 125.039 110.477 124.648C110.789 124.258 111.18 123.951 111.648 123.727C112.122 123.503 112.677 123.391 113.312 123.391C113.974 123.391 114.552 123.526 115.047 123.797C115.542 124.062 115.93 124.427 116.211 124.891C116.497 125.349 116.654 125.87 116.68 126.453H115.305C115.279 126.104 115.18 125.789 115.008 125.508C114.841 125.227 114.612 125.003 114.32 124.836C114.034 124.664 113.698 124.578 113.312 124.578C112.87 124.578 112.497 124.667 112.195 124.844C111.898 125.016 111.661 125.25 111.484 125.547C111.312 125.839 111.188 126.164 111.109 126.523C111.036 126.878 111 127.24 111 127.609V127.938C111 128.307 111.036 128.672 111.109 129.031C111.182 129.391 111.305 129.716 111.477 130.008C111.654 130.299 111.891 130.534 112.188 130.711C112.49 130.883 112.865 130.969 113.312 130.969ZM119.75 120V132H118.305V120H119.75ZM119.406 127.453L118.805 127.43C118.81 126.852 118.896 126.318 119.062 125.828C119.229 125.333 119.464 124.904 119.766 124.539C120.068 124.174 120.427 123.893 120.844 123.695C121.266 123.492 121.732 123.391 122.242 123.391C122.659 123.391 123.034 123.448 123.367 123.562C123.701 123.672 123.984 123.849 124.219 124.094C124.458 124.339 124.641 124.656 124.766 125.047C124.891 125.432 124.953 125.904 124.953 126.461V132H123.5V126.445C123.5 126.003 123.435 125.648 123.305 125.383C123.174 125.112 122.984 124.917 122.734 124.797C122.484 124.672 122.177 124.609 121.812 124.609C121.453 124.609 121.125 124.685 120.828 124.836C120.536 124.987 120.284 125.195 120.07 125.461C119.862 125.727 119.698 126.031 119.578 126.375C119.464 126.714 119.406 127.073 119.406 127.453ZM132.102 130.555V126.203C132.102 125.87 132.034 125.581 131.898 125.336C131.768 125.086 131.57 124.893 131.305 124.758C131.039 124.622 130.711 124.555 130.32 124.555C129.956 124.555 129.635 124.617 129.359 124.742C129.089 124.867 128.875 125.031 128.719 125.234C128.568 125.438 128.492 125.656 128.492 125.891H127.047C127.047 125.589 127.125 125.289 127.281 124.992C127.438 124.695 127.661 124.427 127.953 124.188C128.25 123.943 128.604 123.75 129.016 123.609C129.432 123.464 129.896 123.391 130.406 123.391C131.021 123.391 131.562 123.495 132.031 123.703C132.505 123.911 132.875 124.227 133.141 124.648C133.411 125.065 133.547 125.589 133.547 126.219V130.156C133.547 130.438 133.57 130.737 133.617 131.055C133.669 131.372 133.745 131.646 133.844 131.875V132H132.336C132.263 131.833 132.206 131.612 132.164 131.336C132.122 131.055 132.102 130.794 132.102 130.555ZM132.352 126.875L132.367 127.891H130.906C130.495 127.891 130.128 127.924 129.805 127.992C129.482 128.055 129.211 128.151 128.992 128.281C128.773 128.411 128.607 128.576 128.492 128.773C128.378 128.966 128.32 129.193 128.32 129.453C128.32 129.719 128.38 129.961 128.5 130.18C128.62 130.398 128.799 130.573 129.039 130.703C129.284 130.828 129.583 130.891 129.938 130.891C130.38 130.891 130.771 130.797 131.109 130.609C131.448 130.422 131.716 130.193 131.914 129.922C132.117 129.651 132.227 129.388 132.242 129.133L132.859 129.828C132.823 130.047 132.724 130.289 132.562 130.555C132.401 130.82 132.185 131.076 131.914 131.32C131.648 131.56 131.331 131.76 130.961 131.922C130.596 132.078 130.185 132.156 129.727 132.156C129.154 132.156 128.651 132.044 128.219 131.82C127.792 131.596 127.458 131.297 127.219 130.922C126.984 130.542 126.867 130.117 126.867 129.648C126.867 129.195 126.956 128.797 127.133 128.453C127.31 128.104 127.565 127.815 127.898 127.586C128.232 127.352 128.633 127.174 129.102 127.055C129.57 126.935 130.094 126.875 130.672 126.875H132.352ZM139.359 123.547V124.656H134.789V123.547H139.359ZM136.336 121.492H137.781V129.906C137.781 130.193 137.826 130.409 137.914 130.555C138.003 130.701 138.117 130.797 138.258 130.844C138.398 130.891 138.549 130.914 138.711 130.914C138.831 130.914 138.956 130.904 139.086 130.883C139.221 130.857 139.323 130.836 139.391 130.82L139.398 132C139.284 132.036 139.133 132.07 138.945 132.102C138.763 132.138 138.542 132.156 138.281 132.156C137.927 132.156 137.602 132.086 137.305 131.945C137.008 131.805 136.771 131.57 136.594 131.242C136.422 130.909 136.336 130.461 136.336 129.898V121.492Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.267 87.6C118.267 99.9712 108.238 110 95.8667 110C83.4955 110 73.4667 99.9712 73.4667 87.6C73.4667 75.2288 83.4955 65.2 95.8667 65.2C108.238 65.2 118.267 75.2288 118.267 87.6Z",
    fill: "white"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_24_282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.25 72C73.25 59.4355 83.4355 49.25 96 49.25C108.564 49.25 118.75 59.4355 118.75 72V75.25H107.375C106.478 75.25 105.75 75.9775 105.75 76.875V96.375C105.75 97.2725 106.478 98 107.375 98H115.5C119.09 98 122 95.0898 122 91.5V72C122 57.6406 110.359 46 96 46C81.6406 46 70 57.6406 70 72V91.5C70 95.0898 72.9101 98 76.5 98H84.625C85.5225 98 86.25 97.2725 86.25 96.375V76.875C86.25 75.9775 85.5225 75.25 84.625 75.25H73.25V72Z",
    fill: "url(#paint3_linear_24_282)",
    fillOpacity: 0.3
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_b_24_282)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.935 72C69.935 57.6047 81.6047 45.935 96 45.935C110.395 45.935 122.065 57.6047 122.065 72V91.5C122.065 95.1257 119.126 98.065 115.5 98.065H107.375C106.442 98.065 105.685 97.3084 105.685 96.375V76.875C105.685 75.9416 106.442 75.185 107.375 75.185H118.685V72C118.685 59.4714 108.529 49.315 96 49.315C83.4714 49.315 73.315 59.4714 73.315 72V75.185H84.625C85.5584 75.185 86.315 75.9416 86.315 76.875V96.375C86.315 97.3084 85.5584 98.065 84.625 98.065H76.5C72.8742 98.065 69.935 95.1257 69.935 91.5V72ZM96 46.065C81.6765 46.065 70.065 57.6765 70.065 72V91.5C70.065 95.0539 72.946 97.935 76.5 97.935H84.625C85.4866 97.935 86.185 97.2366 86.185 96.375V76.875C86.185 76.0134 85.4866 75.315 84.625 75.315H73.185V72C73.185 59.3996 83.3996 49.185 96 49.185C108.6 49.185 118.815 59.3996 118.815 72V75.315H107.375C106.513 75.315 105.815 76.0134 105.815 76.875V96.375C105.815 97.2366 106.513 97.935 107.375 97.935H115.5C119.054 97.935 121.935 95.0539 121.935 91.5V72C121.935 57.6765 110.323 46.065 96 46.065Z",
    fill: "url(#paint4_linear_24_282)",
    fillOpacity: 0.3
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.86,
    cy: 83.7,
    rx: 3.9,
    ry: 3.9,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.88,
    cy: 83.7,
    rx: 3.9,
    ry: 3.9,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_24_282",
    x: 3,
    y: 6.40131,
    width: 162.599,
    height: 162.599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -24,
    dy: -24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3155 0 0 0 0 0.075 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_24_282",
    x: 7,
    y: 10.4013,
    width: 178.599,
    height: 178.599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24_282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24_282",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.751506 0 0 0 0 0.608333 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_24_282",
    x: 11,
    y: 14.4013,
    width: 170.599,
    height: 170.599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_24_282",
    x: 27,
    y: 30.4013,
    width: 141.599,
    height: 141.599,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_24_282",
    x: 35.5895,
    y: 32.0609,
    width: 74.241,
    height: 74.241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_24_282",
    x: 92.8873,
    y: 101.486,
    width: 77.6309,
    height: 77.6309,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_24_282",
    x: 19.3312,
    y: 20.5845,
    width: 71.6433,
    height: 69.4601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_24_282",
    x: 21.3648,
    y: 20.6229,
    width: 58.1942,
    height: 56.0424,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5,
    result: "effect1_foregroundBlur_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_24_282",
    x: 0.209656,
    y: 0.816162,
    width: 100.506,
    height: 95.6557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_24_282"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_24_282",
    x: 40,
    y: 16,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24_282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24_282",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_b_24_282",
    x: 39.935,
    y: 15.935,
    width: 112.13,
    height: 112.13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24_282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24_282",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_282",
    x1: 27,
    y1: 30.4013,
    x2: 165.599,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#640DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755208,
    stopColor: "#640DFB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_282",
    x1: 46.4038,
    y1: 49.8051,
    x2: 146.195,
    y2: 149.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#FF5CF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541667,
    stopColor: "#8466FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002FA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_282",
    x1: 27,
    y1: 30.4013,
    x2: 165.599,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#640DFB",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24_282",
    x1: 75.5646,
    y1: 50.7976,
    x2: 131.692,
    y2: 79.8595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A81FF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#567DFF",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E78FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24_282",
    x1: 75.5135,
    y1: 50.7446,
    x2: 131.781,
    y2: 79.8792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#249AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#567DFF",
    stopOpacity: 0.955296
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E78FF",
    stopOpacity: 0.9
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotImg);
export default __webpack_public_path__ + "static/media/BotImg.d8611a4a26859ed482f753c70ae341a4.svg";
export { ForwardRef as ReactComponent };